// src/components/contacts/ContactForm.jsx
import React from 'react';

const ContactForm = ({ data, onChange, companies, isEditMode = false }) => {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  // Prüfe, ob der Kontakt "Allgemein" ist
  const isAllgemein = data.firstName.trim().toLowerCase() === 'allgemein';

  return (
    <>
      <div className="form-group">
        <label>Unternehmen:*</label>
        <select
          value={data.companyId}
          onChange={(e) => handleChange('companyId', e.target.value)}
          required
          className="filter-select"
          disabled={isEditMode && isAllgemein}
        >
          <option value="">Wählen Sie ein Unternehmen</option>
          {companies.map((company) => (
            <option key={company.id} value={company.id}>
              {company.name}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label>Vorname:*</label>
        <input
          type="text"
          value={data.firstName}
          onChange={(e) => handleChange('firstName', e.target.value)}
          required
          disabled={isEditMode && isAllgemein}
        />
      </div>
      <div className="form-group">
        <label>Nachname:</label>
        <input
          type="text"
          value={data.lastName}
          onChange={(e) => handleChange('lastName', e.target.value)}
          disabled={isEditMode && isAllgemein}
        />
      </div>
      <div className="form-group">
        <label>Position:</label>
        <input
          type="text"
          value={data.position}
          onChange={(e) => handleChange('position', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>E-Mail:</label>
        <input
          type="email"
          value={data.email}
          onChange={(e) => handleChange('email', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Telefon:</label>
        <input
          type="text"
          value={data.phone}
          onChange={(e) => handleChange('phone', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Bemerkungen:</label>
        <textarea
          value={data.remarks}
          onChange={(e) => handleChange('remarks', e.target.value)}
        />
      </div>
      <div className="form-group checkbox-group">
        <label>
          <input
            type="checkbox"
            checked={data.isDefault}
            onChange={(e) => handleChange('isDefault', e.target.checked)}
            disabled={isAllgemein} // Nur deaktiviert, wenn der Kontakt "Allgemein" ist
          />
          Standardkontakt
        </label>
      </div>
      {isEditMode && (
        <div className="form-group checkbox-group">
          <label>
            <input type="checkbox" checked={data.active} disabled />
            Aktiv
          </label>
        </div>
      )}
    </>
  );
};

export default ContactForm;